const SELECT_PAYMENT_METHOD = 'checkout/payment/SELECT_PAYMENT_METHOD';
const UPDATE_PAYMENT_DETAILS = 'checkout/payment/UPDATE_PAYMENT_DETAILS';
const SET_PAYMENT_FLOW = 'checkout/SET_PAYMENT_FLOW';
const CLEAR_PAYMENT_FLOW = 'checkout/CLEAR_PAYMENT_FLOW';
const selectPaymentMethod = (payload)=>({
        type: SELECT_PAYMENT_METHOD,
        payload
    })
;

export { CLEAR_PAYMENT_FLOW, SELECT_PAYMENT_METHOD, SET_PAYMENT_FLOW, UPDATE_PAYMENT_DETAILS, selectPaymentMethod };
//# sourceMappingURL=actions.js.map
